import * as Yup from "yup";

export const bookEventSchema = Yup.object().shape({
  event: Yup.object().required("Event is required"),
  time_slot: Yup.number().required("Time is required")
});
